import React from 'react';
import { Section } from './ui/Section';
import { Quote } from 'lucide-react';
export function ExtendedTestimonials() {
  const testimonials = [{
    text: 'Compré un sábado a la noche. El domingo entré al entrenamiento con el plan exacto de la sesión. Las sesiones del Tomo 1 son exactamente lo que necesitaba para organizar mi grupo. Nunca más improviso.',
    author: 'Sebastián M.',
    loc: '📍 Buenos Aires',
    role: 'Instructor de Fútbol Amateur en Club de Barrio'
  }, {
    text: 'El Tomo 4, el de preparación física, me cambió todo. El primer mes, jugadores que llevaban meses estancados mejoraron visiblemente su resistencia y velocidad. El sistema de progresión me da la seguridad que antes no tenía.',
    author: 'Diego R.',
    loc: '📍 Rosario',
    role: 'Profe en Centro Deportivo Municipal'
  }, {
    text: 'El sistema táctico del Tomo 3 es único. 8 corners ofensivos diagramados, sistemas de pressing explicados paso a paso. Antes tardaba horas armando una pizarra. Ahora abro el PDF y en 5 minutos tengo todo listo para mostrarles a los chicos.',
    author: 'Matías F.',
    loc: '📍 Córdoba',
    role: 'Instructor de Fútbol Grupal e Individual'
  }, {
    text: 'Los diagramas tácticos del Bono 3 eliminaron el problema de explicar la táctica. Ahora proyecto el diagrama, lo vemos todos juntos y los jugadores entienden en segundos lo que antes les costaba toda la semana.',
    author: 'Lucas P.',
    loc: '📍 Tucumán',
    role: 'Instructor Particular y en Club Formativo'
  }, {
    text: 'La tasa de abandono de mis grupos bajó muchísimo. Sin cambiar lo que enseño. Solo aplicando el sistema de progresión mensual y la variedad de los 6 tomos. Los pibes ahora quieren venir porque siempre hay algo nuevo.',
    author: 'Gonzalo G.',
    loc: '📍 Mendoza',
    role: 'Instructor de Fútbol Amateur y Formativo'
  }, {
    text: 'Las planillas del Bono 2 me salvaron. Ahora puedo mostrarle al club los resultados reales de cada jugador. Eso me dio autoridad y me ayudó a conseguir más horas de trabajo dentro del mismo club.',
    author: 'Ramiro V.',
    loc: '📍 Santa Fe',
    role: 'Instructor de Fútbol en Club Oficial'
  }, {
    text: 'El Fútbol Táctico Pro me cambió la cabeza. Nunca había dimensionado lo mucho que perdía por no tener un modelo de juego definido. Ahora mis equipos tienen una identidad clara y los jugadores saben exactamente qué se espera de ellos.',
    author: 'Fernando R.',
    loc: '📍 Salta',
    role: 'Instructor y Ayudante de Campo en Club Regional'
  }];
  return <Section className="bg-gray-50" data-id="element-70">
      <div className="text-center max-w-3xl mx-auto mb-6 md:mb-16" data-id="element-71">
        <h2 className="text-2xl md:text-5xl font-black text-dark mb-2 md:mb-4" data-id="element-72">
          Lo que dicen los instructores que ya lo usan:
        </h2>
        <p className="text-base md:text-xl text-primary font-bold" data-id="element-73">
          +300 instructores de fútbol de todo el país ya tienen su Megapack
          Fútbol Resuelto
        </p>
      </div>

      <div className="columns-1 md:columns-2 lg:columns-3 gap-3 md:gap-6 space-y-3 md:space-y-6 max-w-7xl mx-auto" data-id="element-74">
        {testimonials.map((t, i) => <div key={i} className="break-inside-avoid bg-white p-4 md:p-6 rounded-xl md:rounded-2xl shadow-sm border border-gray-100 relative" data-id="element-75">
            <Quote className="absolute top-3 right-3 w-5 h-5 md:w-6 md:h-6 text-gray-200" data-id="element-76" />
            <div className="flex mb-2 md:mb-3" data-id="element-77">
              {[...Array(5)].map((_, j) => <span key={j} className="text-gold text-xs md:text-sm" data-id="element-78">
                  ⭐
                </span>)}
            </div>
            <p className="text-gray-700 italic mb-3 md:mb-5 text-xs md:text-base font-medium leading-relaxed" data-id="element-79">
              "{t.text}"
            </p>
            <div className="border-t border-gray-50 pt-2 md:pt-4 mt-auto" data-id="element-80">
              <p className="font-black text-dark text-sm md:text-base" data-id="element-81">
                {t.author}
              </p>
              <p className="text-[10px] md:text-xs font-bold text-gray-600 mb-0.5" data-id="element-82">
                {t.loc}
              </p>
              <p className="text-[10px] md:text-xs text-gray-500 font-medium" data-id="element-83">
                {t.role}
              </p>
            </div>
          </div>)}
      </div>
    </Section>;
}